class statisticsTaxRateCtrl {
    constructor($scope, httpRequest) {
        // 用户信息
        const userInfo = JSON.parse(localStorage.user_info)
        // 存储页面信息
        $scope.pageState = {
            idToken: localStorage.id_token,
            userInfo,
        }

        // 字典数据
        $scope.dictData = {}
        $scope.dictData.cancel_status = [
            { enumTypeCode: null, enumName: '正常', enumCode: '0' },
            { enumTypeCode: null, enumName: '已作废', enumCode: '1' },
        ]
        const typecodeArr = ['inv_type', 'invoice_status', 'is_red']
        httpRequest.get_dictByTypeArr(typecodeArr).then((res) => {
            $scope.dictData = $.extend($scope.dictData, res.data.value)
        })
    }
}
statisticsTaxRateCtrl.$inject = ['$scope', 'httpRequest']
export default statisticsTaxRateCtrl



// WEBPACK FOOTER //
// ./src/app/statistics/outputStatistics/statisticsTaxRate/statisticsTaxRateCtrl.js